module.exports = __webpack_public_path__ + "static/media/foodndrinks_port_marker.832b2751.svg";